(function () {
    function getQuantity() {
        const modal = document.querySelector(".customily-modal-container, .csh-product-customizer-modal");
        const input = modal?.querySelector(".js-quantity-field-pdp") || document.querySelector(".js-quantity-field-pdp");
        return parseInt(input?.value || "1");
    }

    function readCustomilyProperties() {
        const modal = document.querySelector(".customily-modal-container, .csh-product-customizer-modal");
        if (!modal) return {};
        const inputs = modal.querySelectorAll('[name^="properties["]');
        const props = {};
        inputs.forEach((input) => {
            const match = input.name.match(/properties\[(.*?)\]/);
            if (!match) return;
            const key = match[1].trim();
            if (input.type === "radio" || input.type === "checkbox") {
                if (input.checked) props[key] = input.value || "✓";
            } else {
                const val = input.value?.trim();
                if (val) props[key] = val;
            }
        });
        return props;
    }

    // Proprietà che sappiamo arrivare in ritardo nel DOM rispetto al click
    // (Customily le scrive in modo asincrono). Facciamo polling su entrambe,
    // non solo sulla thumb.
    const PROPRIETA_IN_RITARDO = ["_customily-thumb", "_customily-preview"];

    function leggiValoreProprieta(nome) {
        const input = document.querySelector(`input[name="properties[${nome}]"]`);
        return input?.value?.trim() || "";
    }

    // --- LOGICA DI CORREZIONE POST-CARRELLO ---
    // Riceve direttamente l'item restituito da /cart/add.js: niente più
    // "indovina la posizione nell'array del carrello".
    async function fixCartItem(addedItem, qty, extraProps) {
        try {
            // 1. Polling per TUTTE le proprietà che possono arrivare in ritardo
            //    (thumb + preview), non solo la thumb.
            const trovate = {};
            let attempts = 0;
            const daTrovare = new Set(PROPRIETA_IN_RITARDO);

            while (attempts < 10 && daTrovare.size > 0) {
                for (const nome of Array.from(daTrovare)) {
                    const val = leggiValoreProprieta(nome);
                    if (val.startsWith("http")) {
                        trovate[nome] = val;
                        daTrovare.delete(nome);
                    }
                }
                if (daTrovare.size === 0) break;
                await new Promise(r => setTimeout(r, 400));
                attempts++;
            }

            if (daTrovare.size > 0) {
                console.warn("[CustomilyFix] Proprietà non trovate dopo il polling (ancora assenti nel DOM):", Array.from(daTrovare));
            }

            Object.assign(extraProps, trovate);

            // 2. Identifichiamo l'item corretto tramite la sua key,
            //    NON tramite cart.items[0] (che è il PRIMO item del carrello,
            //    non l'ultimo aggiunto).
            const itemKey = addedItem.key || addedItem.id;
            if (!itemKey) {
                console.error("[CustomilyFix] Impossibile determinare la key dell'item appena aggiunto.", addedItem);
                return;
            }

            console.info("[CustomilyFix] Correggo item:", itemKey, "con properties:", extraProps);

            const res = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: itemKey,
                    quantity: qty,
                    properties: { ...addedItem.properties, ...extraProps }
                }),
            });

            if (!res.ok) {
                console.error("[CustomilyFix] /cart/change.js ha risposto con errore:", res.status, await res.text());
                return;
            }

            console.info("[CustomilyFix] Carrello corretto con successo.");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (err) {
            console.error("[CustomilyFix] Errore nella correzione:", err);
        }
    }

    // --- OBSERVER ---
    const observer = new MutationObserver(() => {
        const btn = document.querySelector("#customily-cart-btn");
        if (!btn || btn.dataset._bound) return;
        btn.dataset._bound = "true";

        btn.addEventListener("click", () => {
            // Salviamo i dati PRIMA che il form venga resettato
            const qty = getQuantity();
            const propsAtClick = readCustomilyProperties();

            // Intercettiamo la fetch solo per sapere QUANDO Customily ha finito
            const originalFetch = window.fetch;
            window.fetch = async (url, options) => {
                const isAdd = typeof url === "string" && url.includes("/cart/add.js");

                const result = await originalFetch(url, options);

                if (isAdd && result.ok) {
                    window.fetch = originalFetch; // Reset immediato

                    // Cloniamo la response per poterla leggere senza interferire
                    // con chi la consuma più avanti nel codice del tema/Customily.
                    const clone = result.clone();
                    let addedItem = null;
                    try {
                        addedItem = await clone.json();
                    } catch (e) {
                        console.error("[CustomilyFix] Impossibile leggere la response di /cart/add.js", e);
                    }

                    if (addedItem) {
                        await fixCartItem(addedItem, qty, propsAtClick);
                    }

                }
                return result;
            };
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();